import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import SFDialog from "../dialog";

const ConfirmDialog = ({
  onClose,
  title,
  confirmationMessages,
  stepperName,
}) => {
  const stepperReduxState = useSelector((state) => {
    return state.stepper.find((stepper) => stepper.name === stepperName);
  });

  if (!stepperReduxState) {
    return null;
  }

  return (
    <SFDialog
      variant="info"
      title={title}
      message={stepperReduxState.dialog.finish
        ? confirmationMessages.submit
        : confirmationMessages.cancel}
      open={stepperReduxState.dialog.open}
      onClose={onClose.bind(this, false)}
      primaryButton
      primaryButtonProps={{
        label: confirmationMessages?.submitBtnLabel,
        onClick: onClose.bind(this, true),
        async: true,
      }}
      secondaryButton
      secondaryButtonProps={{
        onClick: onClose.bind(this, false),
      }}
    />
  );
};

ConfirmDialog.propTypes = {
  finish: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  stepperName: PropTypes.string.isRequired,
  title: PropTypes.node,
  confirmationMessages: PropTypes.shape({
    submit: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    cancel: PropTypes.string,
    submitBtnLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
};

export default ConfirmDialog;
